module.exports = __webpack_public_path__ + "img/growth.63caaa07.png";